import React from 'react';
import ReactApexChart from 'react-apexcharts';

class StackedBarChart extends React.Component {
    constructor(props) {
        super(props);
        
        // Extract the data from props
        const { data } = this.props;
        
        this.state = {
            series: [
                {
                    name: 'RDEC',
                    data: [
                        data.new.rdec || 0,
                        data.inprogress.rdec || 0,
                        data.complete.rdec || 0,
                    ],
                },
                {
                    name: 'SME',
                    data: [
                        data.new.sme || 0,
                        data.inprogress.sme || 0,
                        data.complete.sme || 0,
                    ],
                },
                {
                    name: 'Mixed',
                    data: [
                        data.new.mixed || 0,
                        data.inprogress.mixed || 0,
                        data.complete.mixed || 0,
                    ],
                },
                {
                    name: 'Merged',
                    data: [
                        data.new.merged || 0,
                        data.inprogress.merged || 0,
                        data.complete.merged || 0,
                    ],
                },
            ],
            options: {
                chart: {
                    id: 'chart1',
                    type: 'bar',
                    height: 350,
                    width: '50%',
                    stacked: true,
                    toolbar: {
                        show: true,
                    },
                },

                responsive: [
                    {
                        breakpoint: 480,
                        options: {
                            legend: {
                                position: 'bottom',
                                offsetX: -10,
                                offsetY: 0,
                            },
                        },
                    },
                ],
                plotOptions: {
                    bar: {
                        horizontal: false,
                    },
                },

                xaxis: {
                    type: 'category',
                    categories: ['New', 'In-progress', 'Complete'],
                },
                legend: {
                    position: 'right',
                    offsetY: 40,
                },
                fill: {
                    opacity: 1,
                    colors: ['#70B7E1', '#7AB51C', '#EF8030', '#ff4560'],
                },
            },
        };
    }

    render() {
        return (
            <div id="chart">
                <ReactApexChart
                    options={this.state.options}
                    series={this.state.series}
                    type="bar"
                    height={350}
                />
            </div>
        );
    }
}

export default StackedBarChart;
